import React from 'react';
import { DetailRow } from '../../ComplaintTypePolicy/Elements/PolicyDetails';

const ConfigDetails = ({ config }) => {
  if (!config) return null;

  return (
    <div className='tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-bg-white tw-flex tw-flex-col'>
      <DetailRow title='Model' value={config.model} />
      <DetailRow title='Prompt' value={config.prompt} />
    </div>
  );
};

export default ConfigDetails;
